import { render } from "./sapin.vue?vue&type=template&id=22185e85"
import script from "./sapin.vue?vue&type=script&lang=js"
export * from "./sapin.vue?vue&type=script&lang=js"

import "./sapin.vue?vue&type=style&index=0&id=22185e85&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__